// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__16mNP","logoLink":"Navbar_logoLink__1Ruvl","logo":"Navbar_logo__2-mzM","dropdown":"Navbar_dropdown__2tObY","content":"Navbar_content__37cvs"};